import React from 'react'

function TermsAndConditions() {
  return (
    <div className='p-4'>
        <h2>TERMS & CONDITIONS</h2>

        <h3>2.1 Acceptance of Terms</h3>
        <p>
          By using any Burgeon Group service, you agree to these terms.
        </p>

        <h3>2.2 User Responsibilities</h3>
        <ul>
          <li>You must be 18+</li>
          <li>Keep account credentials secure</li>
          <li>Provide accurate information</li>
        </ul>

        <h3>2.3 Pricing & Payments</h3>
        <ul>
          <li><strong>Technology:</strong> Subscription billing</li>
          <li><strong>Organic Food:</strong> Seasonal pricing</li>
          <li><strong>Construction:</strong> Progress payments</li>
          <li><strong>Travel:</strong> Advance payment required</li>
        </ul>
        <br/>
        <h3>CONTACT INFORMATION</h3>
        <p>
          <strong>Email:</strong> info@burgeon-grp.com
        </p>
    </div>
  )
}

export default TermsAndConditions